"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Radio = void 0;

var _react = _interopRequireDefault(require("react"));

var _formik = require("formik");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var Radio = function Radio(props) {
  var _props$label, _props$options, _props$help;

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (props === null || props === void 0 ? void 0 : (_props$label = props.label) === null || _props$label === void 0 ? void 0 : _props$label.length) > 0 && (props === null || props === void 0 ? void 0 : props.type) !== 'hidden' && /*#__PURE__*/_react["default"].createElement("p", {
    className: "mb-[8px]"
  }, props.label, props.required && /*#__PURE__*/_react["default"].createElement("sup", {
    className: "text-brand-danger"
  }, "*")), (props === null || props === void 0 ? void 0 : (_props$options = props.options) === null || _props$options === void 0 ? void 0 : _props$options.length) > 0 && /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: props.name
  }, function (_ref) {
    var field = _ref.field,
        form = _ref.form;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "mb-[15px]"
    }, props.options.map(function (option, idx) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex items-center cursor-pointer ".concat(idx > 0 ? 'mt-[10px]' : 'mt-0'),
        key: option.value
      }, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "radio",
        id: option.value.replaceAll(' ', '-')
      }, field, {
        value: option.value,
        disabled: form.isSubmitting,
        checked: field.value === option.value,
        onChange: function onChange(e) {
          return form.setFieldValue(field.name, e.target.value);
        },
        style: {
          boxShadow: field.value === option.value ? 'inset 0 0 0px 2px #fff' : 'none'
        },
        "class": "appearance-none w-4 h-4 !border rounded-full checked:border-brand-secondary checked:bg-brand-secondary mr-[10px]"
      })), option.label.length > 0 && /*#__PURE__*/_react["default"].createElement("label", {
        className: "mb-0 text-sm cursor-pointer",
        htmlFor: option.value.replaceAll(' ', '-')
      }, option.label));
    }));
  }), (props === null || props === void 0 ? void 0 : (_props$help = props.help) === null || _props$help === void 0 ? void 0 : _props$help.length) > 0 && (props === null || props === void 0 ? void 0 : props.type) !== 'hidden' && /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-brand-dark-grey text-[12px] mb-[15px] md:mb-[30px]"
  }, props.help));
};

exports.Radio = Radio;